import React from 'react'
import classNames from 'classnames'

import css from './RadioButton.styles.scss'

import { RadioButtonProps } from './RadioButton.types'

const radioButtonSizeClassname = (size: RadioButtonProps['size']) => {
  switch (size) {
    case 'sm':
      return css.radio_button__small
    case 'md':
      return css.radio_button__medium
    case 'lg':
      return css.radio_button__large
    default:
      return css.radio_button__medium
  }
}

const radioButtonTypeClassname = (type: RadioButtonProps['type']) => {
  switch (type) {
    case 'primary':
      return css.radio_button__primary
    case 'secondary':
      return css.radio_button__secondary
    default:
      return css.radio_button__primary
  }
}

const RadioButton: React.FC<RadioButtonProps> = ({
  type = 'primary',
  size,
  className,
  invalid = false,
  inputProps = {},
}) => {
  const RadioButtonClasses = classNames(
    css.radio_button__wrapper,
    radioButtonTypeClassname(type),
    radioButtonSizeClassname(size),
    {
      [css.radio_button__invalid]: invalid,
    },
    className
  )

  return (
    <span className={RadioButtonClasses}>
      <input
        type="radio"
        {...inputProps}
        className={classNames(css.radio_button__reset, css.radio_button__input)}
      />
      <div aria-hidden="true" className={css.radio_button__dot_wrapper}>
        <div className={css.radio_button__dot} />
      </div>
    </span>
  )
}

export default RadioButton
